<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <!-- <div class="col-sm-12"> -->
          <div class="row">
            <div class="col-sm-12">
              <vs-breadcrumb
                align="left"
                :items="
                  [
                    {title: 'You are here: '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/Trainer/trainerDashboard?training='+this.AssigntrainingCode
                    },
                    {
                      title: 'Quick Participant Registration',
                      active: true
                    }
                  ]
                    "
              ></vs-breadcrumb>
              <div class="heading mt-3">
                <h3 class="text-secondary">Quick Participant Registration</h3>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 mb-3">
          <div class="form-group form-row text-dark">
            <h6 class="sub-frm-title">Event Information</h6>
            <div class="row col-sm-12">
              <label class="col-sm-1 font-weight-bold">Title:</label>
              <div class="col-sm-11" v-if="trainingDetails">{{trainingDetails.title}}</div>
            </div>
          </div>
          <b-card v-if="isForm" style="border: 1px dotted #07a7e14f;">
            <form @submit.prevent="quickRegistration">
              <div>
                <div
                  class="row dblock mt-3"
                  style="padding: 15px;box-shadow: 0 0 15px 0 rgba(0,0,0,.05);"
                >
                  <!-- Information starts -->
                  <div class="form-group form-row">
                    <h6 class="sub-frm-title">Information</h6>
                    <div class="row col-sm-12">
                      <input
                        class="floating-input form-control"
                        hidden
                        type="text"
                        placeholder=" "
                        v-model="currentTrainingId"
                      />
                      <div class="col-sm-6">
                        <div class="floating-label">
                          <input
                            class="floating-input form-control"
                            style="text-transform: default;"
                            type="text"
                            placeholder=" "
                            v-model="name"
                             autocomplete="off"
                          />
                          <span
                            class="lbl-label"
                            style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                          >
                            <i class="material-icons" style="font-size: 20px;">account_circle</i>
                          </span>
                          <label class="lbl-label">
                            Name
                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                          </label>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="floating-label">
                          <input
                            class="floating-input form-control"
                            style="text-transform: default;"
                            type="text"
                            placeholder=" "
                            v-model="username"
                             autocomplete="off"
                          />
                          <span
                            class="lbl-label"
                            style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                          >
                            <i class="material-icons" style="font-size: 20px;">account_circle</i>
                          </span>
                          <label class="lbl-label">
                           User Name
                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                          </label>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="floating-label">
                          <input
                            class="floating-input form-control"
                            v-mask="'(99999) 9999999-9'"
                            type="text"
                            placeholder=" "
                            v-model="cnic"
                             autocomplete="off"
                          />

                          <span
                            class="lbl-label"
                            style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                          >
                            <i class="material-icons" style="font-size: 20px;">credit_card</i>
                          </span>
                          <label class="lbl-label">
                            CNIC Number
                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                          </label>
                        </div>
                      </div>
                      <div class="col-sm-6 mt-3">
                        <div class="floating-label">
                          <input
                            class="floating-input form-control"
                            v-mask="'(9999)-9999999'"
                            type="text"
                            placeholder=" "
                            v-model="mobilenumber"
                             autocomplete="off"
                          />

                          <span
                            class="lbl-label"
                            style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                          >
                            <i class="material-icons" style="font-size: 20px;">call</i>
                          </span>
                          <label class="lbl-label">
                            Contact
                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                          </label>
                        </div>
                      </div>
                      <div class="col-sm-6 mt-3">
                        <div class="floating-label">
                          <input
                            class="floating-input form-control"
                            v-model="passport"
                            type="text"
                            placeholder=" "
                             autocomplete="off"
                          />
                          <span
                            class="lbl-label"
                            style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                          >
                            <i class="material-icons" style="font-size: 20px;">credit_card</i>
                          </span>
                          <label class="lbl-label">
                            Passport
                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                          </label>
                        </div>
                      </div>
                      <div class="col-sm-6 mt-3">
                        <div class="floating-label">
                          <input
                            class="floating-input form-control"
                            type="email"
                            placeholder=" "
                            v-model="email"
                          />

                          <span
                            class="lbl-label"
                            style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                          >
                            <i class="material-icons" style="font-size: 20px;">email</i>
                          </span>
                          <label class="lbl-label">
                            Email
                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                          </label>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-6 mt-3">
                        <div class="floating-label">
                          <input
                            class="floating-input form-control"
                            v-model="code"
                            type="text"
                            placeholder=" "
                          />

                          <span
                            class="lbl-label"
                            style="float: right;margin-top: -25px;padding: 0px 5px;color:#ccc;"
                          >
                            <i class="material-icons" style="font-size: 20px;">code</i>
                          </span>
                          <label class="lbl-label">
                            Employee Code (This will use as password)
                            <span
                              style="color:rgba(255, 0, 0, 0.78);"
                            >*</span>
                          </label>
                        </div>
                      </div>

                      <div class="col-sm-6 mt-3">
                        <div class="floating-label">
                          <input
                            class="floating-input form-control"
                            hidden
                            type="text"
                            placeholder=" "
                            v-model="role"
                             autocomplete="off"
                          />

                          <span
                            class="lbl-label"
                            style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                          ></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--Detail Information ends -->

                  <!-- save button starts-->
                  <b-button type="submit" class="save-btn" variant="primary">Save</b-button>
                  <!-- save button ends -->
                </div>
              </div>
            </form>
          </b-card>
        </div>
        <b-card v-if="isEditForm" style="border: 1px dotted #07a7e14f;">
          <form @submit.prevent="submitEditForm">
            <div class="form-group">
              <div class="row">
                <!-- floating input starts -->
                <div class="col-sm-6">
                  <div class="floating-label">
                    <input
                      class="floating-input form-control"
                      style="text-transform: uppercase;"
                      type="text"
                      placeholder=" "
                      v-model="name"
                       autocomplete="off"
                    />
                    <span
                      class="lbl-label"
                      style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                    >
                      <i class="material-icons" style="font-size: 20px;">account_circle</i>
                    </span>
                    <label class="lbl-label">Name</label>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="floating-label">
                    <input
        
                      class="floating-input form-control"
                      v-mask="'(99999) 9999999-9'"
                      type="text"
                      placeholder=" "
                      v-model="cnic"
                       autocomplete="off"
                    />

                    <span
                      class="lbl-label"
                      style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                    >
                      <i class="material-icons" style="font-size: 20px;">credit_card</i>
                    </span>
                    <label class="lbl-label">CNIC Number</label>
                  </div>
                </div>
                <div class="col-sm-6 mt-3">
                  <div class="floating-label">
                    <input
                      class="floating-input form-control"
                      v-mask="'(9999)-9999999'"
                      type="text"
                      placeholder=" "
                      v-model="mobilenumber"
                       autocomplete="off"
                    />

                    <span
                      class="lbl-label"
                      style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                    >
                      <i class="material-icons" style="font-size: 20px;">call</i>
                    </span>
                    <label class="lbl-label">Contact</label>
                  </div>
                </div>
                <div class="col-sm-6 mt-3">
                  <div class="floating-label">
                    <input
                      class="floating-input form-control"
                      v-model="passport"
                      type="text"
                      placeholder=" "
                       autocomplete="off"
                    />
                    <span
                      class="lbl-label"
                      style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                    >
                      <i class="material-icons" style="font-size: 20px;">credit_card</i>
                    </span>
                    <label class="lbl-label">Passport</label>
                  </div>
                </div>
                <div class="col-sm-6 mt-3">
                  <div class="floating-label">
                    <input
                      class="floating-input form-control"
                      disabled
                      type="email"
                      placeholder=" "
                      v-model="email"
                       autocomplete="off"
                    />

                    <span
                      class="lbl-label"
                      style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                    >
                      <i class="material-icons" style="font-size: 20px;">email</i>
                    </span>
                    <label class="lbl-label">Email</label>
                  </div>
                </div>
                <div class="col-md-6 col-lg-6 mt-3">
                  <div class="floating-label">
                    <input
                      class="floating-input form-control"
                      v-model="code"
                      type="text"
                      placeholder=" "
                       autocomplete="off"
                    />

                    <span
                      class="lbl-label"
                      style="float: right;margin-top: -25px;padding: 0px 5px;color:#ccc;"
                    >
                      <i class="material-icons" style="font-size: 20px;">code</i>
                    </span>
                    <label class="lbl-label">Employee Code (This will use as password)</label>
                  </div>
                </div>
                <!-- Gender ends -->
              </div>
            </div>
            <input type="hidden" v-model="userId" />
            <input type="hidden" v-model="primaryUserId" />

            <div class="form-group">
              <div class="row">
                <div class="col-sm-12">
                  <!-- add button starts-->
                  <b-button pill type="submit" class="save-btn" variant="primary">Update</b-button>
                  <b-button pill v-if="!isForm" @click="closeEditForm" variant="outline-info">Cancel</b-button>
                  <!-- add button ends -->
                </div>
              </div>
            </div>
          </form>
        </b-card>

        <div class="col-sm-12">
          <!-- new form popup starts -->
          <b-card>
            <div class="form-group">
              <div class="row">
                <div class="col-sm-12">
                  <div class="table-responsive">
                    <table class="table table-hover">
                      <tr>
                        <th>Sr#</th>
                        <th>Name</th>
                        <th>Gender</th>
                        <th>CNIC Number</th>
                        <th>Passport</th>
                        <th>Contact Number</th>
                        <th>Email</th>
                        <th>Code</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>

                      <tr v-for="(item, index) in itemsTrainee" v-bind:key="item.id">
                        <td>{{index+1}}</td>
                        <td
                          v-if="item.trainee.userstrainee.name != null"
                          class="text-capitalize"
                        >{{item.trainee.userstrainee.name}}</td>
                        <td v-else>N/A</td>
                        <td
                          v-if="item.trainee.userstrainee.gender != null"
                        >{{item.trainee.userstrainee.gender}}</td>
                        <td v-else>N/A</td>
                        <td v-if="item.trainee.cnic != null">{{item.trainee.cnic}}</td>
                        <td v-else>N/A</td>
                        <td v-if="item.trainee.passportNo != null">{{item.trainee.passportNo}}</td>
                        <td v-else>N/A</td>
                        <td
                          v-if="item.trainee.userstrainee.contactNo != null"
                        >{{item.trainee.userstrainee.contactNo}}</td>
                        <td v-else>N/A</td>
                        <td
                          v-if="item.trainee.userstrainee.username != null"
                          class="text-transform:lowercase"
                        >{{item.trainee.userstrainee.username}}</td>
                        <td v-else>N/A</td>
                        <td
                          v-if="item.trainee.userstrainee.code != null"
                        >{{item.trainee.userstrainee.code}}</td>
                        <td v-else>N/A</td>
                        <td>
                          <vs-chip v-if="item.trainee.statusApproval == '1'" color="primary">Pending</vs-chip>
                          <vs-chip
                            v-if="item.trainee.statusApproval == '2'"
                            color="success"
                          >Approved</vs-chip>
                          <vs-chip v-if="item.trainee.statusApproval == '3'" color="danger">Reject</vs-chip>
                        </td>
                        <td v-if="currentUserID == item.trainee.user_id">
                          <a @click="editRecord(item.trainee.id)">
                            <vs-icon
                              class
                              icon="edit"
                              style="color:#007bff;font-size:20px;font-weight:600;cursor: pointer;"
                            ></vs-icon>
                          </a>
                          <!--  <a @click="deleteRecord(item.id)">
                                  <vs-icon
                                    class="mr-1"
                                    icon="delete"
                                    style="color:#ff0000c7;font-size:20px;font-weight:600;cursor: pointer;"
                                  ></vs-icon>
                          </a>-->
                        </td>
                        <td></td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </b-card>
          <!-- new form popup ends -->
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";


export default {
  data: () => ({
    isEditForm: false,
    isSidebar: false,
    whichSelect: 0,
    role: "",
    designation: "",
    valuesArray: [],
    options1: [
      { text: "Passport", value: 0 },
      { text: "CNIC", value: 1 }
    ],
    radios1: "",
    trainingId: "",
    currentTrainingId: "",
    gender: "",
    success: "",
    inValid: [],
    trainingDetails: [],
    updateTraining: [],
    isForm: true,
    isFormData: false,
    selected: "",
    tabIndex: 0,
    contact_person: "",
    email: "",
    contact_number: "",
    contact_email: "",
    mobilenumber: "",
    primaryUserId: "",
    cnic: "",
    name: "",
    passport: "",
    address: "",
    components: {
      // VueTagsInput
    },
    country: 1,
    province: 1,
    tag: "",
    tags: [],
    rolesArr: [],
    roleuser: "",
    departmentArr: [],
    department: "",
    designationArr: [],
    sessionByArray: [],
    checkBox1: false,
    checkBox2: false,
    checkBox3: false,
    checkBox4: false,
    textarea: "",
    counterDanger: false,
    mydate: "",
    startDate: "",
    endDate: "",
    colorx: "#1db952",
    currentUserID: "",
    indexActive: 0,
    trainingCheck: false,
    repeatedCheck: false,
    select1Normal: "",
    select1: 0,
    userId: 0,
    select2: 1,
    select3: 0,
    select4: 1,
    select5: 1,
    select6: 1,
    select7: 1,
    select8: 1,
    select9: 1,
    select10: 0,
    select11: 1,
    select12: 1,
    select13: 1,
    select14: 1,
    code: "",
    username:"",
    thematicareaSelected: "",
    thematicareasettings: {
      valueField: "code",
      labelField: "name",
      maxItems: 5,
      plugins: ["remove_button"],
      delimiter: "|"
    },
    traineridentityArr: [
      { text: "CNIC Number", value: 1 },
      {
        text: "Passport Number",
        value: 2
      }
    ],

    languageskillsArr: [
      { text: "English", value: 1 },
      { text: "French", value: 2 },
      { text: "German", value: 3 },
      { text: "Chinese", value: 4 }
    ],
    selectlevelArr: [
      { text: "Good", value: 1 },
      { text: "Very Good", value: 2 },
      { text: "Excellent", value: 3 },
      { text: "Weak", value: 4 }
    ],
    countryArr: [],
    trainingArr: [],
    provinceArr: [],
    districtArr: [],
    degreenameArr: [],
    degreesubjectArr: [
      { text: "Management Science", value: 1 },
      { text: "Computer Science", value: 2 },
      { text: "Software Engineering", value: 3 }
    ],
    jobnatureArr: [
      { text: "Permanent", value: 1 },
      { text: "Temporary", value: 2 }
    ],
    itemsTrainee: [],
    items: [
      {
        contact_person: "Dr Saif Ullah",
        department: "Police Dedpartment KP",
        city: "Mardan"
      },

      {
        contact_person: "Dr Ata Ullah",
        department: "Police Dedpartment ISLAMABAD",
        city: "Peshawar"
      }
    ],
    fields: [
      { key: "city", label: "City" },
      { key: "department", label: "Department" },
      { key: "contact_person", label: "Contact Person" },
      { key: "actions", label: "" }
    ]
  }),
  watch: {},
  created() {
    this.AssigntrainingCode = this.$route.query.training;
  },
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    this.currentUserID = JSON.parse(localStorage.getItem("currentUser")).id;
    this.openLoading();
    axios
      .get(
        process.env.VUE_APP_BASE_PATH +
          "/get/trainer/trainee/training/" +
          this.AssigntrainingCode
     
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        if (response.data) {
          this.trainingDetails = response.data;
          this.currentTrainingId = response.data.id;
          this.allTrainer();
        }
      });
    //console.log(this.currentUserID);
    // Set the initial number of items
    //Select all countries

    //this.trainingId = this.$route.query.trainingId;
    /* axios
      .get(
        process.env.VUE_APP_BASE_PATH +
          "/get/trainer/trainingdetails/" +
          JSON.parse(localStorage.getItem("currentUser")).id +
          ""
     
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        if (response.data && response.data.trainingDetails) {
          this.trainingId = response.data.trainingDetails.id;
          this.trainingDetails = response.data.trainingDetails;
        }
      }); */

    /* this.openLoading();
    axios
      .get(
        process.env.VUE_APP_BASE_PATH +
          "/programOfficer/trainingsingle/get/" +
          this.trainingId
     
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.updateTraining = response.data.training;
      });
    this.openLoading();
    axios
      .get(process.env.VUE_APP_BASE_PATH + "/countries/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.countryArr = response.data;
        // this.provinceArr=response.data;
      }); */
    //get result of trainers
    /* this.openLoading();
    axios
      .get(process.env.VUE_APP_BASE_PATH + "/trainers/all/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.valuesArray = response.data;
      }); */

    //select all provinces
    /* this.openLoading();
    axios
      .get(process.env.VUE_APP_BASE_PATH + "/provinces/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.provinceArr = response.data;
      }); */
    //select all district
    /* this.openLoading();
    axios
      .get(process.env.VUE_APP_BASE_PATH + "/districts/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.districtArr = response.data;
      }); */
    //select all degree names
    /* this.openLoading();
    axios
      .get(process.env.VUE_APP_BASE_PATH + "/degreenames/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.degreenameArr = response.data;
      }); */
    // department
    /* this.openLoading();
    axios
      .get(process.env.VUE_APP_BASE_PATH + "/departments/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.departmentArr = response.data;
      }); */
    //designation
    /* this.openLoading();
    axios
      .get(process.env.VUE_APP_BASE_PATH + "/designations/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.designationArr = response.data;
      }); */
    // axios.get(process.env.VUE_APP_BASE_PATH+'/trainers/get').then(response => {
    //   this.sessionByArray = response.data;
    // });
    this.openLoading();
    axios
      .get(process.env.VUE_APP_BASE_PATH + "/traineeroles/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.role = response.data[0].id;
      });
    //select all Training Name
    /* this.openLoading();
    axios
      .get(process.env.VUE_APP_BASE_PATH + "/trainers/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.trainingArr = response.data;
      }); */
  },
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  },

  methods: {
    closeEditForm() {
      this.isForm = true;
      this.isEditForm = false;
      this.resetForm();
    },
    editRecord(id) {
      this.isForm = false;
      this.isEditForm = true;
      // this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH + "/trainee/user/" + id + "/edit"
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          // this.closeLoading();
          if (response) {
            this.name = response.data.userstrainee.name;
            this.code = response.data.userstrainee.code;
            this.mobilenumber = response.data.userstrainee.contactNo;
            this.email = response.data.userstrainee.username;
            this.cnic = response.data.cnic;
            this.passport = response.data.passportNo;
            this.userId = id;
            this.primaryUserId = response.data.user_trainee_id;
            // this will scrollTop to edit form
            window.scrollTo(0, 0);
          }
        });
    },
    deleteRecord(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value == true) {
            this.openLoading();
            axios
              .post(process.env.VUE_APP_BASE_PATH + "/trainee/delete", {
                id: id
              })
              .then(response => {
                alert(id);
                this.closeLoading();
                if (response.data.success) {
                  this.$toasted.global.successMsg("Record has been deleted successfully!");
                  this.allTrainer();
                } else if (response.data.error) {
                  throw response.data.error;
                }
              })
              .catch(error => {
                this.$toasted.global.errorMsg(error);
              });
          }
        });
    },
    allTrainer: function allTrainer() {
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/trainer/trainee/show/" +
            this.currentTrainingId +
            "/" +
            JSON.parse(localStorage.getItem("currentUser")).id
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.itemsTrainee = response.data;
        });
    },
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    toastSuccess(msg) {
      this.$bvToast.toast(msg, {
        title: "Success",
        autoHideDelay: 10000,
        variant: "success",
        solid: true
      });
    },
    toastError(msg) {
      this.$bvToast.toast(msg, {
        title: "Error",
        autoHideDelay: 10000,
        variant: "danger",
        solid: true
      });
    },
    showinputvalue: function(event) {
      this.name = event.target.value;
    },
    //Quick training
    quickRegistration(e) {
      e.preventDefault();
      this.inValid = [];
      if (!this.name) {
        this.inValid.push("Name is required.");
      }
      if (!this.username) {
        this.inValid.push("Username is required.");
      }
      if (!this.mobilenumber) {
        this.inValid.push("Mobile Number is required.");
      }
      if (!this.email) {
        this.inValid.push("Email type is required.");
      }
      var phone_no1 = this.mobilenumber;
      if (phone_no1 == null || phone_no1 == undefined) {
        this.inValid.push("Must be valid Number, 0345-9992229");
      } else {
        phone_no1 = phone_no1.replace(/_/g, "");
        if (phone_no1.length < 14) {
          this.inValid.push("Must be valid Number, 0345-9992229");
        }
      }
      var cnic_var = this.cnic;
      if (cnic_var != null && cnic_var != undefined && cnic_var != "") {
        cnic_var = cnic_var.replace(/_/g, "");
        if (cnic_var.length < 17) {
          this.inValid.push("Must be valid CNIC, 16101-1114812-3");
        }
      } else if (
        this.passport == undefined ||
        this.passport == null ||
        this.passport == ""
      ) {
        this.inValid.push("Please Enter Passport Number");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;
        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/register/trainee", {
            //insert User informatiion in user table
            name: this.name,
            username:this.username,
            code: this.code,
            role: this.role,
            contactNo: this.mobilenumber,
            email: this.email,
            sessionBy: this.currentTrainingId,
            //insert trainee quick information in trainee table
            user_id: JSON.parse(localStorage.getItem("currentUser")).id,
            cnic: this.cnic,
            statusApproval: 1, // It will be pending status
            passport: this.passport,
            type: "Quick Registration"
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.allTrainer();
              self.resetForm();
              self.toastSuccess("Record has been added successfully!");
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    submitEditForm(e) {
      e.preventDefault();
      this.inValid = [];
      if (!this.name) {
        this.inValid.push("Name is required.");
      }
      if (!this.mobilenumber) {
        this.inValid.push("Mobile Number is required.");
      }
      if (!this.email) {
        this.inValid.push("Email type is required.");
      }
      var phone_no1 = this.mobilenumber;
      if (phone_no1 == null || phone_no1 == undefined) {
        this.inValid.push("Must be valid Number, 0345-9992229");
      } else {
        phone_no1 = phone_no1.replace(/_/g, "");
        if (phone_no1.length < 14) {
          this.inValid.push("Must be valid Number, 0345-9992229");
        }
      }
      var cnic_var = this.cnic;
      if (cnic_var != null && cnic_var != undefined && cnic_var != "") {
        cnic_var = cnic_var.replace(/_/g, "");
        if (cnic_var.length < 17) {
          this.inValid.push("Must be valid CNIC, 16101-1114812-3");
        }
      } else if (
        this.passport == undefined ||
        this.passport == null ||
        this.passport == ""
      ) {
        this.inValid.push("Please Enter Passport Number");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/trainee/update", {
            //insert User informatiion in user table

            name: this.name,
            code: this.code,
            role: this.role,
            contactNo: this.mobilenumber,
            email: this.email,
            statusApproval: 1, // Already Approved
            //insert trainee quick information in trainee table
            user_id: JSON.parse(localStorage.getItem("currentUser")).id,
            cnic: this.cnic,
            passport: this.passport,
            type: "Quick Registration",
            id: this.userId,
            primaryUserId: this.primaryUserId
          })

          .then(response => {
            if (response.data.success) {
              self.toastSuccess("Record has been updated successfully!");
              self.resetForm();
              self.allTrainer();
              this.isForm = true;
              this.isEditForm = false;
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    resetForm() {
      this.name = "";
      this.cnic = "";
      this.code = "";
      this.passport = "";
      this.gender = "";
      this.mobilenumber = "";
      this.email = "";
      this.country = "";
      this.province = "";
      this.district = "";
      this.address = "";
      this.department_name = "";
      this.designation = "";
      this.certificate = "";
      this.passing_year = "";
      this.institute = "";
    },
    successUpload() {
      this.$vs.notify({
        color: "primary",
        title: "Upload Success",
        text: "Your file is uploaded Successfully."
      });
    },
    showForm() {
      this.isForm = false;
      this.isFormData = true;
    }
  }
};
</script>

<style scoped>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
.mt-45 {
  margin-top: 45px !important;
}
button:focus {
  outline: transparent !important;
  outline: transparent -webkit-focus-ring-color !important;
}
.dblock {
  display: block !important;
}
.input-color {
  margin-bottom: 10px;
  position: relative;
  display: block;
}
.myNavbar {
  color: rgb(255, 255, 255);
}
.dflex {
  display: flex;
}
.fcenter {
  justify-content: center;
  align-items: center;
}
.pleft-5 {
  margin-left: 5px;
}
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
}
.con-select .vs-select {
  width: 100%;
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
}

.form-row {
  padding: 8px;
  color: #1465a3;
  border: 1px dotted #07a7e14f;
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.field {
  width: 100%;
  text-transform: capitalize;
  border-bottom: 2px solid #d0d0d0;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  transition: all 0.2s ease-in-out 0.2s;
  -webkit-transition: all 0.2s ease-in-out 0.2s;
  -moz-transition: all 0.2s ease-in-out 0.2s;
}
.sub-frm-title {
  padding: 5px;
  background-color: #ffffff;
  margin-top: -25px;
  text-align: center;
  color: rgba(7, 167, 225, 0.61);
}
/* overide css of vuesax */
.vs-con-input-label {
  width: 100% !important;
}
.vs-con-input-label.is-label-placeholder {
  margin-top: 8px !important;
}
.frm-title {
  text-align: center;
  padding: 10px;
  color: #009ad2;
  /* border-bottom: 2px solid #009ad2; */
}
.save-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  float: right;
  margin: 10px 0px;
}
.previous-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  float: left;
  margin: 10px 0px;
}
.add-locations-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  margin: 10px 0px;
}
.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
}

.new-training {
  padding-right: 10px;
}
.title-text {
  margin-bottom: 0px;
}
.selectize-control.multi .selectize-input > div {
  background: rgba(7, 167, 225, 0.61);
  color: #333333;
}
.con-select {
  font-size: 0.85rem !important;
}
.selectize-input.items.not-full.has-options.has-items {
  font-size: 0.85rem !important;
}

/* Floating label css starts */
/****  floating-Lable style start ****/
.floating-label {
  position: relative;
  margin-bottom: 5px;
}
.floating-input,
.floating-select {
  font-size: 14px;
  padding: 4px 30px 4px 5px;
  display: block;
  width: 100%;
  height: 36px;
  box-shadow: none !important;
  /* background-color: transparent; */
  border: none;
  border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
  outline: none;
  border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
  color: #ccc;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 6px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.floating-input:focus ~ label.lbl-label,
.floating-input:not(:placeholder-shown) ~ label.lbl-label {
  background-color: #fff;
  /* background-color: #fff; */
  top: -12px;
  left: 10px;
  font-size: 14px;
  color: rgba(7, 167, 225, 0.61);
  padding: 0px 5px;
}

.floating-select:focus ~ llabel.lbl-label,
.floating-select:not([value=""]):valid ~ label.lbl-label {
  top: -18px;
  font-size: 14px;
  color: #5264ae;
}

/* active state */
.floating-input:focus ~ .bar:before,
.floating-input:focus ~ .bar:after,
.floating-select:focus ~ .bar:before,
.floating-select:focus ~ .bar:after {
  width: 50%;
}

*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

/* highlighter */
/* .highlight {
  position: absolute;
  height: 50%;
  width: 100%;
  top: 15%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
} */

/* active state */
.floating-input:focus ~ .highlight,
.floating-select:focus ~ .highlight {
  -webkit-animation: inputHighlighter 0.3s ease;
  -moz-animation: inputHighlighter 0.3s ease;
  animation: inputHighlighter 0.3s ease;
}

/* animation */
@-webkit-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@-moz-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
/****  floating-Lable style end ****/
/* Floating label css ends */

.add-btn {
  font-size: 25px;
  color: rgba(7, 167, 225, 0.61);
  cursor: pointer;
}
.delete-btn {
  font-size: 25px;
  color: rgba(255, 0, 0, 0.78);
  cursor: pointer;
}
</style>
